import { HttpRequest } from '@angular/common/http';

// These GETs are resolved server-side from the request IP (web-api
// resolveDeviceContext / resolveDeviceMode). During SSR that IP is the render
// server's egress — not the device's — so letting them into the hydration
// transfer cache hands the browser a device mode resolved for the datacenter's
// location. They must always be re-fetched by the browser itself.
const DEVICE_MODE_SENSITIVE_PATHS = ['/self', '/self/validate', '/self/recent-games'];
const DEVICE_MODE_SENSITIVE_PREFIXES = ['/promotions', '/games', '/game-collections', '/game-providers', '/hero-cards'];

export const httpTransferCacheFilter = (req: HttpRequest<unknown>): boolean => {
  const pathname = new URL(req.url, 'http://relative-url-base').pathname;

  return (
    !DEVICE_MODE_SENSITIVE_PATHS.includes(pathname) &&
    !DEVICE_MODE_SENSITIVE_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))
  );
};
